import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "./utils";

const badgeVariants = cva(
  "inline-flex items-center gap-1.5 rounded-full px-3 py-1.5 text-xs font-semibold transition-colors",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground",
        secondary: "bg-bg-secondary/70 text-text-supporting border border-border-default font-medium",
        accent: "bg-accent-primary/10 text-accent-primary border border-accent-primary/20",
        outline: "border border-border-default text-text-primary",
        warning: "bg-accent-warning/10 text-accent-warning border border-accent-warning/20",
        success: "bg-green-600/15 text-green-800 dark:bg-green-400/20 dark:text-green-200 border border-green-600/35 dark:border-green-300/35 tracking-wide",
        filled: "bg-accent-primary text-text-on-accent",
      },
      size: {
        default: "px-3 py-1.5",
        sm: "px-2 py-0.5 text-[10px]",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, size, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant, size }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
